module.exports = __webpack_public_path__ + "static/media/failed-capture-ten.0b6671fe.png";